export enum ContactUsMessages {
  developedBy = "contactUs.developedBy",
  topcon = "contactUs.topcon",
  allRightsReserved = "contactUs.allRightsReserved"
}

export type TranslationContactUsMessages = {
  [key in ContactUsMessages]: string;
}
